import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

import Breadcrumb from "./Breadcrumb/reducer";

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"
//chat
import chat from "./chat/reducer";

//Calendar
import Calendar from "./calendar/reducer"

//tasks
import Tasks from "./tasks/reducer";

// Companies
import Companies from "./companies/reducer"

// Plans
import Plans from "./plans/reducer"

// System Users
import SystemUsers from "./systemUsers/reducer"

// Roles
import Roles from "./roles/reducer"

// Admin Dashboard
import DashboardAdmin from "./dashboardAdmin/reducer"

// Admin Invoices
import InvoicesAdmin from "./invoicesAdmin/reducer"

// Admin Settings
import SettingsAdmin from "./settingsAdmin/reducer"

// Admin Permissions
import Permissions from "./permissions/reducer"

// Customers
import Customers from "./customers/reducer"

// Company Users
import CompanyUsers from "./companyUsers/reducer"

// Invoices
import Invoices from "./invoices/reducer"

// Admin Tickets
import TicketsAdmin from "./ticketsAdmin/reducer"

// Products
import Products from "./products/reducer"

// Quotes
import Quotes from "./quotes/reducer"

// Tickets
import Tickets from "./tickets/reducer"

// Dashboard Company
import DashboardCompany from "./dashboardCompany/reducer"

// Suppliers
import Suppliers from "./suppliers/reducer"

const rootReducer = combineReducers({
  // public
  Layout,
  //Breadcrumb items
  Breadcrumb,
  Tasks,
  Login,
  Account,
  ForgetPassword,
  Profile,
  Calendar,
  chat,
  Companies,
  Plans,
  SystemUsers,
  Roles,
  Permissions,
  Customers,
  CompanyUsers,
  Invoices,
  DashboardAdmin,
  InvoicesAdmin,
  SettingsAdmin,
  TicketsAdmin,
  Products,
  Quotes,
  Tickets,
  DashboardCompany,
  Suppliers,
})

export default rootReducer
